<template>
  <!-- Add Asset Modal -->
  <div id="add_asset" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ assetForm?.asset_id ? "Edit" : "Add" }} {{ assetType }} Asset
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            ref="asset_modal_close"
            @click="clearForm"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <!-- Tabs Header -->
          <!-- <div class="row">
            <ul class="nav nav-tabs" id="assetTabs" role="tablist">
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  :class="{ active: activeTab === 'it' }"
                  id="it-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#it"
                  type="button"
                  role="tab"
                  aria-controls="it"
                  :aria-selected="activeTab === 'it'"
                  @click="activeTab = 'it'"
                >
                  IT Assets
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  :class="{ active: activeTab === 'nonit' }"
                  id="nonit-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nonit"
                  type="button"
                  role="tab"
                  aria-controls="nonit"
                  :aria-selected="activeTab === 'nonit'"
                  @click="activeTab = 'nonit'"
                >
                  Non-IT Assets
                </button>
              </li>
            </ul>
          </div> -->
          <div class="row">
            <!-- <div class="col-md-4">
              <div class="input-block mb-3">
                <label class="col-form-label"
                  >Asset Name <span class="text-danger">*</span></label
                >
                <input
                  class="form-control"
                  type="text"
                  v-model="assetForm.name"
                  @change="handleChangeEvent('name')"
                  :class="{ 'is-invalid': clientError.includes('name') }"
                />
                <span
                  class="text-danger"
                  v-if="errors && errors?.name && errors?.name != null"
                  >{{ errors?.name[0] }}</span
                >
              </div>
            </div> -->
            <div class="col-md-4">
              <div class="input-block mb-3">
                <label class="col-form-label"
                  >Asset ID <span class="text-danger">*</span></label
                >
                <input
                  class="form-control"
                  type="text"
                  v-model="assetForm.uuid"
                  @change="handleChangeEvent('uuid')"
                  :class="{ 'is-invalid': clientError.includes('uuid') }"
                />
                <span
                  class="text-danger"
                  v-if="errors && errors?.uuid && errors?.uuid != null"
                  >{{ errors?.uuid[0] }}</span
                >
              </div>
            </div>
            <div class="col-md-4">
              <div class="input-block mb-3">
                <label class="col-form-label"
                  >Asset Type <span class="text-danger">*</span></label
                >
                <input
                  class="form-control"
                  type="text"
                  v-model="assetForm.type"
                  @change="handleChangeEvent('type')"
                  :class="{ 'is-invalid': clientError.includes('type') }"
                />
                <span
                  class="text-danger"
                  v-if="errors && errors?.type && errors?.type != null"
                  >{{ errors?.type[0] }}</span
                >
              </div>
            </div>
            <div class="col-md-4">
              <div class="input-block mb-3">
                <label class="col-form-label"
                  >Brand/Model <span class="text-danger">*</span></label
                >
                <input
                  class="form-control"
                  type="text"
                  v-model="assetForm.model"
                  @change="handleChangeEvent('model')"
                  :class="{ 'is-invalid': clientError.includes('model') }"
                />
                <span
                  class="text-danger"
                  v-if="errors && errors?.model && errors?.model != null"
                  >{{ errors?.model[0] }}</span
                >
              </div>
            </div>
            <div class="col-md-4">
              <div class="input-block mb-3">
                <label class="col-form-label"
                  >Serial Number <span class="text-danger">*</span></label
                >
                <input
                  class="form-control"
                  type="text"
                  v-model="assetForm.serial_number"
                  @change="handleChangeEvent('serial_number')"
                  :class="{
                    'is-invalid': clientError.includes('serial_number'),
                  }"
                />
                <span
                  class="text-danger"
                  v-if="
                    errors &&
                    errors?.serial_number &&
                    errors?.serial_number != null
                  "
                  >{{ errors?.serial_number[0] }}</span
                >
              </div>
            </div>
            <div class="col-md-4">
              <div class="input-block mb-3">
                <label class="col-form-label">Invoice Number</label>
                <input
                  class="form-control"
                  type="text"
                  v-model="assetForm.invoice_number"
                  @change="handleChangeEvent('invoice_number')"
                  :class="{
                    'is-invalid': clientError.includes('invoice_number'),
                  }"
                />
                <span
                  class="text-danger"
                  v-if="
                    errors &&
                    errors?.invoice_number &&
                    errors?.invoice_number != null
                  "
                  >{{ errors?.invoice_number[0] }}</span
                >
              </div>
            </div>
            <div class="col-md-4">
              <div class="input-block mb-3">
                <label class="col-form-label"
                  >Assigned To
                  <span v-if="assetType === 'IT'" class="text-danger"
                    >*</span
                  ></label
                >
                <vue-select
                  v-model="assetForm.asset_user_id"
                  :options="employees.map((e) => ({ id: e.id, text: e.text }))"
                  :placeholder="'Select Employee'"
                  :searchable="true"
                  :allow-clear="true"
                  :settings="{ dropdownParent: '#add_asset' }"
                  :class="{
                    'is-invalid': clientError.includes('asset_user_id'),
                  }"
                  @change="handleEmployeeChange"
                />

                <span
                  class="text-danger"
                  v-if="
                    errors &&
                    errors?.asset_user_id &&
                    errors?.asset_user_id != null
                  "
                >
                  {{ errors?.asset_user_id[0] }}
                </span>
              </div>
            </div>

            <div class="col-md-4">
              <div class="input-block mb-3">
                <label class="col-form-label"
                  >Employee Id <span v-if="assetType === 'IT'" class="text-danger">*</span></label
                >
                <vue-select
                  v-model="assetForm.employee_id"
                  :options="
                    employees.map((e) => ({
                      id: e.employee_id,
                      text: e.label_id,
                    }))
                  "
                  :placeholder="'Select Employee ID'"
                  :searchable="true"
                  :allow-clear="true"
                  :settings="{ dropdownParent: '#add_asset' }"
                  :class="{ 'is-invalid': clientError.includes('employee_id') }"
                  @change="handleEmployeeIdChange"
                />

                <span
                  class="text-danger"
                  v-if="
                    errors && errors?.employee_id && errors?.employee_id != null
                  "
                  >{{ errors?.employee_id[0] }}</span
                >
              </div>
            </div>

            <div class="col-md-4">
              <div class="input-block mb-3">
                <label class="col-form-label"
                  >Department <span class="text-danger">*</span></label
                >
                <select
                  @change="handleChangeEvent('department_id')"
                  v-model="assetForm.department_id"
                  class="form-select"
                  placeholder="Select Department"
                  :class="{
                    'is-invalid': clientError.includes('department_id'),
                  }"
                >
                  <option disabled value="">Select Department</option>
                  <option
                    v-for="dprtmnt in Departments"
                    :key="dprtmnt?.id"
                    :value="dprtmnt?.id"
                  >
                    {{ dprtmnt?.name }}
                  </option>
                </select>
                <span
                  class="text-danger"
                  v-if="
                    errors &&
                    errors?.department_id &&
                    errors?.department_id != null
                  "
                  >{{ errors?.department_id[0] }}</span
                >
              </div>
            </div>
            <div class="col-md-4">
              <div class="input-block mb-3">
                <label class="col-form-label"
                  >Account Name
                  <span v-if="assetType === 'IT'" class="text-danger">*</span>
                </label>
                <input
                  class="form-control"
                  type="text"
                  v-model="assetForm.account_name"
                  @change="handleChangeEvent('account_name')"
                  :class="{
                    'is-invalid': clientError.includes('account_name'),
                  }"
                />
                <span
                  class="text-danger"
                  v-if="
                    errors &&
                    errors?.account_name &&
                    errors?.account_name != null
                  "
                  >{{ errors?.account_name[0] }}</span
                >
              </div>
            </div>
            <div class="col-md-4">
              <div class="input-block mb-3">
                <label class="col-form-label"
                  >Purchase Date <span class="text-danger">*</span></label
                >
                <datepicker
                  v-model="startdate"
                  class="form-control floating datetimepicker"
                  :editable="true"
                  :clearable="false"
                  :input-format="dateFormat"
                  @change="handleChangeEvent('purchase_date')"
                  :class="{
                    'is-invalid': clientError.includes('purchase_date'),
                  }"
                />
                <span
                  class="text-danger"
                  v-if="
                    errors &&
                    errors?.purchase_date &&
                    errors?.purchase_date != null
                  "
                  >{{ errors?.purchase_date[0] }}</span
                >
              </div>
            </div>
            <!-- <div class="col-md-4">
              <div class="input-block mb-3">
                <label class="col-form-label"
                  >Vendor Name <span class="text-danger">*</span></label
                >
                <input
                  class="form-control"
                  type="text"
                  v-model="assetForm.purchase_from"
                  @change="handleChangeEvent('purchase_from')"
                  :class="{
                    'is-invalid': clientError.includes('purchase_from'),
                  }"
                />
                <span
                  class="text-danger"
                  v-if="
                    errors &&
                    errors?.purchase_from &&
                    errors?.purchase_from != null
                  "
                  >{{ errors?.purchase_from[0] }}</span
                >
              </div>
            </div> -->

            <!-- <div class="col-md-4">
              <div class="input-block mb-3">
                <label class="col-form-label"
                  >Manufacturer <span class="text-danger">*</span></label
                >
                <input
                  class="form-control"
                  type="text"
                  v-model="assetForm.manufacturer"
                  @change="handleChangeEvent('manufacturer')"
                  :class="{
                    'is-invalid': clientError.includes('manufacturer'),
                  }"
                />
                <span
                  class="text-danger"
                  v-if="
                    errors &&
                    errors?.manufacturer &&
                    errors?.manufacturer != null
                  "
                  >{{ errors?.manufacturer[0] }}</span
                >
              </div>
            </div> -->

            <!-- <div class="col-md-4">
              <div class="input-block mb-3">
                <label class="col-form-label">Brand </label>
                <input
                  class="form-control"
                  type="text"
                  v-model="assetForm.brand"
                  @change="handleChangeEvent('brand')"
                  :class="{ 'is-invalid': clientError.includes('brand') }"
                />
                <span
                  class="text-danger"
                  v-if="errors && errors?.brand && errors?.brand != null"
                  >{{ errors?.brand[0] }}</span
                >
              </div>
            </div> -->
            <!-- <div class="col-md-4">
              <div class="input-block mb-3">
                <label class="col-form-label">Supplier</label>
                <input
                  class="form-control"
                  type="text"
                  v-model="assetForm.supplier"
                  @change="handleChangeEvent('supplier')"
                  :class="{ 'is-invalid': clientError.includes('supplier') }"
                />
                <span
                  class="text-danger"
                  v-if="errors && errors?.supplier && errors?.supplier != null"
                  >{{ errors?.supplier[0] }}</span
                >
              </div>
            </div> -->

            <!-- <div class="col-md-4">
              <div class="input-block mb-3">
                <label class="col-form-label"
                  >Warranty <span class="text-danger">*</span></label
                >
                <input
                  class="form-control"
                  type="number"
                  placeholder="In Months"
                  v-model="assetForm.warranty"
                  @change="handleChangeEvent('warranty')"
                  :class="{ 'is-invalid': clientError.includes('warranty') }"
                />
                <span
                  class="text-danger"
                  v-if="errors && errors?.warranty && errors?.warranty != null"
                  >{{ errors?.warranty[0] }}</span
                >
              </div>
            </div> -->
            <!-- <div class="col-md-4">
              <div class="input-block mb-3">
                <label class="col-form-label"
                  >Days to Expire <span class="text-danger">*</span></label
                >
                <input
                  class="form-control"
                  type="number"
                  placeholder="In Days"
                  v-model="assetForm.days_to_expire"
                  @change="handleChangeEvent('days_to_expire')"
                  :class="{
                    'is-invalid': clientError.includes('days_to_expire'),
                  }"
                />
                <span
                  class="text-danger"
                  v-if="
                    errors &&
                    errors?.days_to_expire &&
                    errors?.days_to_expire != null
                  "
                  >{{ errors?.days_to_expire[0] }}</span
                >
              </div>
            </div> -->
            <div class="col-md-4">
              <div class="input-block mb-3">
                <label class="col-form-label"
                  >Purchase Price <span class="text-danger">*</span></label
                >
                <input
                  :placeholder="currency"
                  @change="handleChangeEvent('value')"
                  class="form-control"
                  type="number"
                  v-model="assetForm.value"
                  :class="{ 'is-invalid': clientError.includes('value') }"
                />
                <span
                  class="text-danger"
                  v-if="errors && errors?.value && errors?.value != null"
                  >{{ errors?.value[0] }}</span
                >
              </div>
            </div>

            <!-- <div class="col-md-4">
              <div class="input-block mb-3">
                <label class="col-form-label">Warranty Start Date</label>
                <datepicker
                  v-model="warrantyStartDate"
                  class="form-control floating datetimepicker"
                  :editable="true"
                  :clearable="false"
                  :input-format="dateFormat"
                  @change="handleChangeEvent('warranty_start_date')"
                  :class="{
                    'is-invalid': clientError.includes('warranty_start_date'),
                  }"
                />
                <span class="text-danger" v-if="errors?.warranty_start_date">
                  {{ errors?.warranty_start_date[0] }}
                </span>
              </div>
            </div> -->

            <div class="col-md-4">
              <div class="input-block mb-3">
                <label class="col-form-label"
                  >Warranty Expiry <span class="text-danger">*</span></label
                >
                <datepicker
                  v-model="warrantyEndDate"
                  class="form-control floating datetimepicker"
                  :editable="true"
                  :clearable="false"
                  :input-format="dateFormat"
                  @change="handleChangeEvent('warranty_end_date')"
                  :class="{
                    'is-invalid': clientError.includes('warranty_end_date'),
                  }"
                />
                <span class="text-danger" v-if="errors?.warranty_end_date">
                  {{ errors?.warranty_end_date[0] }}
                </span>
              </div>
            </div>
            <div class="col-md-4">
              <div class="input-block mb-3">
                <label class="col-form-label"
                  >Location <span class="text-danger">*</span></label
                >
                <input
                  class="form-control"
                  type="text"
                  v-model="assetForm.location"
                  @change="handleChangeEvent('location')"
                  :class="{
                    'is-invalid': clientError.includes('location'),
                  }"
                />
                <span
                  class="text-danger"
                  v-if="errors && errors?.location && errors?.location != null"
                  >{{ errors?.location[0] }}</span
                >
              </div>
            </div>
            <div class="col-md-4">
              <div class="input-block mb-3">
                <label class="col-form-label"
                  >Status <span class="text-danger">*</span></label
                >
                <select
                  v-model="assetForm.status"
                  @change="handleChangeEvent('status')"
                  :class="{ 'is-invalid': clientError.includes('status') }"
                  class="form-select"
                >
                  <option disabled value="">Select Status</option>
                  <option
                    v-for="(st, index) in addassetstatus"
                    :key="'status_' + index"
                    :value="st"
                  >
                    {{ st }}
                  </option>
                </select>
                <span
                  class="text-danger"
                  v-if="errors && errors?.status && errors?.status != null"
                  >{{ errors?.status[0] }}</span
                >
              </div>
            </div>
            <div class="col-md-4">
              <div class="input-block mb-3">
                <label class="col-form-label"
                  >Condition <span class="text-danger">*</span></label
                >
                <input
                  class="form-control"
                  type="text"
                  v-model="assetForm.condition"
                  @change="handleChangeEvent('condition')"
                  :class="{ 'is-invalid': clientError.includes('condition') }"
                />
                <span
                  class="text-danger"
                  v-if="
                    errors && errors?.condition && errors?.condition != null
                  "
                  >{{ errors?.condition[0] }}</span
                >
              </div>
            </div>
            <div class="col-md-4">
              <div class="input-block mb-3">
                <label class="col-form-label"
                  >Last Audit Date <span class="text-danger">*</span></label
                >
                <datepicker
                  v-model="auditDate"
                  class="form-control floating datetimepicker"
                  :editable="true"
                  :clearable="false"
                  :input-format="dateFormat"
                  @change="handleChangeEvent('last_audit_date')"
                  :class="{
                    'is-invalid': clientError.includes('last_audit_date'),
                  }"
                />
                <span class="text-danger" v-if="errors?.last_audit_date">
                  {{ errors?.last_audit_date[0] }}
                </span>
              </div>
            </div>
            <div class="col-md-4">
              <div class="input-block mb-3">
                <label class="col-form-label"
                  >Notes <span class="text-danger">*</span></label
                >
                <textarea
                  class="form-control"
                  @change="handleChangeEvent('description')"
                  v-model="assetForm.description"
                  :class="{ 'is-invalid': clientError.includes('description') }"
                ></textarea>
                <span
                  class="text-danger"
                  v-if="
                    errors && errors?.description && errors?.description != null
                  "
                  >{{ errors?.description[0] }}</span
                >
              </div>
            </div>
            <!-- Duplicate Check -->
            <div class="col-md-4">
              <div class="form-check form-switch mt-4">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="isDuplicate"
                  v-model="assetForm.is_duplicate"
                  @change="handleChangeEvent('is_duplicate')"
                />
                <label class="form-check-label ms-3 mt-2" for="isDuplicate"
                  >Is Duplicate?</label
                >
                <span class="text-danger" v-if="errors?.is_duplicate">
                  {{ errors?.is_duplicate[0] }}
                </span>
              </div>
            </div>
            <div class="col-md-4">
              <div class="input-block mb-3">
                <label class="col-form-label"
                  >Room Number
                  <span v-if="assetType === 'Non-IT'" class="text-danger"
                    >*</span
                  ></label
                >
                <input
                  class="form-control"
                  type="text"
                  v-model="assetForm.room"
                  @change="handleChangeEvent('room')"
                  :class="{ 'is-invalid': clientError.includes('room') }"
                />
                <span
                  class="text-danger"
                  v-if="errors && errors?.room && errors?.room != null"
                  >{{ errors?.room[0] }}</span
                >
              </div>
            </div>
            <div class="col-md-4">
              <div class="input-block mb-3">
                <label class="col-form-label"
                  >Purchase Order Number
                  <span class="text-danger">*</span></label
                >
                <input
                  class="form-control"
                  type="text"
                  v-model="assetForm.purchase_order_no"
                  @change="handleChangeEvent('purchase_order_no')"
                  :class="{
                    'is-invalid': clientError.includes('purchase_order_no'),
                  }"
                />
                <span
                  class="text-danger"
                  v-if="
                    errors &&
                    errors?.purchase_order_no &&
                    errors?.purchase_order_no != null
                  "
                  >{{ errors?.purchase_order_no[0] }}</span
                >
              </div>
            </div>
            <div class="col-md-12">
              <label class="col-form-label">Upload File </label>
              <input
                type="file"
                class="form-control"
                data-buttontext="Choose File"
                data-icon="false"
                data-classbutton="btn btn-default"
                data-classinput="form-control inline input-s"
                name="documents[]"
                multiple
                accept=".jpg, .jpeg, .png, .doc, .docx, .pdf"
                ref="attachments"
              />
              <span
                class="text-danger"
                v-if="errors && errors?.document && errors?.document != null"
                >{{ errors?.document[0] }}</span
              >
            </div>
          </div>
          <div class="submit-section">
            <button
              class="btn btn-primary submit-btn"
              @click="onSubmitForm"
              :disabled="disabledButton"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Asset Modal -->

  <!-- Delete Asset Modal -->
  <div class="modal custom-modal fade" id="delete_asset" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="form-header">
            <h3>Delete Asset</h3>
            <p>Are you sure want to delete?</p>
          </div>
          <div class="modal-btn delete-action">
            <div class="row">
              <div class="col-6">
                <a
                  href="javascript:void(0);"
                  class="btn btn-primary continue-btn"
                  @click="$emit('delete-asset')"
                  >Delete</a
                >
              </div>
              <div class="col-6">
                <a
                  href="javascript:void(0);"
                  data-bs-dismiss="modal"
                  ref="close_asset_delete_modal"
                  class="btn btn-primary cancel-btn"
                  >Cancel</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete Asset Modal -->
</template>
<script>
import axios from "axios";
import { ref } from "vue";
const currentDate = ref(new Date());
const currentDateOne = ref(new Date());
import { notification } from "ant-design-vue";
import moment from "moment";
import { mapActions, mapGetters } from "vuex";

export default {
  emits: ["reloadAssetData", "delete-asset"],
  props: {
    assetClear: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    closeDeleteModal: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    editData: {
      type: Object,
      required: false,
      default: () => null,
    },
    assetType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      select2: null,
      addassetsuser: ["John Doe", "Richard Miles"],
      addassetstatus: ["Pending", "Approved", "Deployed", "Damaged"],
      editassetsuser: ["John Doe", "Richard Miles"],
      editassetstatus: ["Pending", "Approved", "Deployed", "Damaged"],
      startdate: currentDate,
      dateFormat: "dd-MM-yyyy",
      auditDate: currentDateOne,
      warrantyStartDate: new Date(),
      warrantyEndDate: new Date(),
      assetForm: {
        asset_id: null,
        asset_type: "it",
        uuid: "",
        name: "",
        account_name: "",
        purchase_date: "",
        purchase_from: "",
        manufacturer: "",
        model: "",
        type: "",
        room: "",
        brand: "",
        serial_number: "",
        invoice_number: "",
        supplier: "",
        condition: "",
        warranty: "",
        days_to_expire: "",
        value: "",
        last_audit_date: "",
        warranty_start_date: "",
        warranty_end_date: "",
        employee_id: "",
        asset_user_id: "",
        department_id: "",
        is_duplicate: false,
        location: "",
        description: "",
        status: "",
        purchase_order_no: "",
      },
      // activeTab: "it",
      clientError: [],
      errors: [],
      disabledButton: false,
      employees: [],
    };
  },
  computed: {
    ...mapGetters(["getAllDepartments"]),
    Departments() {
      return this.getAllDepartments ? this.getAllDepartments : [];
    },
    currency() {
      return this.$store.state.currency || "$";
    },
  },
  watch: {
    assetClear(newVal) {
      if (newVal) {
        this.clearForm();
        const randomNumber = Math.floor(100000 + Math.random() * 900000);
        this.assetForm.uuid = "AST-" + randomNumber;
      }
    },
    closeDeleteModal(newVal) {
      if (newVal) {
        this.$refs.close_asset_delete_modal.click();
      }
    },
    editData(newVal) {
      if (newVal?.asset_id) {
        this.assetForm = { ...newVal };
        this.startdate = newVal?.purchase_date
          ? new Date(newVal?.purchase_date)
          : null;
        this.warrantyStartDate = newVal?.warranty_start_date
          ? new Date(newVal?.warranty_start_date)
          : null;
        this.warrantyEndDate = newVal?.warranty_end_date
          ? new Date(newVal?.warranty_end_date)
          : null;
        this.auditDate = newVal?.last_audit_date
          ? new Date(newVal?.last_audit_date)
          : null;
        this.assetForm.is_duplicate = newVal?.is_duplicate ? true : false;
        // this.assetForm.employee_id = newVal?.user.employee_id;

        // if (newVal?.asset_type === "Non-IT") {
        //   this.activeTab = "nonit";
        // } else {
        //   this.activeTab = "it";
        // }
      }
    },
  },
  methods: {
    ...mapActions(["fetchAllDepartments"]),
    handleChangeEvent(target) {
      this.clientError = this.clientError.filter((item) => item !== target);
    },
    handleEmployeeChange(value) {
      this.assetForm.asset_user_id = value;
      this.handleChangeEvent("asset_user_id");

      const selectedEmployee = this.employees.find((emp) => emp.id === value);
      if (selectedEmployee) {
        this.assetForm.employee_id = selectedEmployee.employee_id;
      }
    },
    handleEmployeeIdChange(value) {
      this.assetForm.employee_id = value;
      this.handleChangeEvent("employee_id");

      const selectedEmployee = this.employees.find(
        (emp) => emp.employee_id === value
      );
      if (selectedEmployee) {
        this.assetForm.asset_user_id = selectedEmployee.id;
      }
    },
    clearForm() {
      this.assetForm = {
        asset_id: null,
        asset_type: "it",
        uuid: "",
        name: "",
        account_name: "",
        purchase_date: "",
        purchase_from: "",
        manufacturer: "",
        model: "",
        type: "",
        room: "",
        brand: "",
        serial_number: "",
        invoice_number: "",
        supplier: "",
        condition: "",
        warranty: "",
        days_to_expire: "",
        value: "",
        last_audit_date: "",
        warranty_start_date: "",
        warranty_end_date: "",
        employee_id: "",
        asset_user_id: "",
        department_id: "",
        is_duplicate: false,
        location: "",
        description: "",
        status: "",
        purchase_order_no: "",
      };
      this.activeTab = "it";
      this.startdate = new Date();
      this.auditDate = new Date();
      this.warrantyStartDate = new Date();
      this.warrantyEndDate = new Date();
      this.clientError = [];
      this.errors = [];
    },
    async onSubmitForm() {
      this.clientError = [];
      this.errors = [];
      this.disabledButton = true;

      const isEmpty = (val) =>
        val === null ||
        val === undefined ||
        val === "" ||
        val === "null" ||
        (typeof val === "string" && val.trim() === "");

      if (isEmpty(this.assetForm?.uuid)) this.clientError.push("uuid");
      // if (isEmpty(this.assetForm?.name)) this.clientError.push("name");

      if (this.assetType === "IT" && isEmpty(this.assetForm?.account_name))
        this.clientError.push("account_name");

      if (this.assetType === "Non-IT" && isEmpty(this.assetForm?.room))
        this.clientError.push("room");

      if (isEmpty(this.assetForm?.serial_number))
        this.clientError.push("serial_number");

      if (isEmpty(this.assetForm?.purchase_order_no))
        this.clientError.push("purchase_order_no");

      // if (isEmpty(this.assetForm?.employee_id))
      //   this.clientError.push("employee_id");

      // if (isEmpty(this.assetForm?.asset_user_id))
      //   this.clientError.push("asset_user_id");

      if (isEmpty(this.assetForm?.department_id))
        this.clientError.push("department_id");

      // if (!isNaN(this.startdate.getTime())) {
      //   var dd = this.startdate;
      //   dd.setMonth(dd.getMonth() + 1);
      //   const year = dd.getFullYear();
      //   const month = dd.getMonth().toString().padStart(2, "0");
      //   const day = dd.getDate().toString().padStart(2, "0");
      //   this.assetForm.purchase_date = `${year}-${month}-${day}`;
      // } else {
      //   this.clientError.push("purchase_date");
      // }

      if (this.startdate) {
        this.assetForm.purchase_date = moment(this.startdate).format(
          "YYYY-MM-DD"
        );
      } else {
        this.clientError.push("purchase_date");
      }

      // if (isEmpty(this.assetForm?.manufacturer))
      //   this.clientError.push("manufacturer");

      if (isEmpty(this.assetForm?.value)) this.clientError.push("value");

      if (isEmpty(this.assetForm?.condition))
        this.clientError.push("condition");

      if (isEmpty(this.assetForm?.status)) this.clientError.push("status");

      if (isEmpty(this.assetForm?.type)) this.clientError.push("type");

      if (isEmpty(this.assetForm?.model)) this.clientError.push("model");

      // if (isEmpty(this.assetForm?.warranty)) this.clientError.push("warranty");

      // if (isEmpty(this.assetForm?.days_to_expire))
      //   this.clientError.push("days_to_expire");

      if (isEmpty(this.assetForm?.location)) this.clientError.push("location");

      if (isEmpty(this.assetForm?.description))
        this.clientError.push("description");

      // if (this.warrantyStartDate) {
      //   this.assetForm.warranty_start_date = moment(
      //     this.warrantyStartDate
      //   ).format("YYYY-MM-DD");
      // }

      if (this.warrantyEndDate) {
        this.assetForm.warranty_end_date = moment(this.warrantyEndDate).format(
          "YYYY-MM-DD"
        );
      } else {
        this.clientError.push("warranty_end_date");
      }

      if (this.auditDate) {
        this.assetForm.last_audit_date = moment(this.auditDate).format(
          "YYYY-MM-DD"
        );
      } else {
        this.clientError.push("last_audit_date");
      }

      this.assetForm.asset_type = this.assetType;

      // this.assetForm.warranty = this.assetForm.warranty
      //   ? parseInt(this.assetForm.warranty)
      //   : "";

      // this.assetForm.days_to_expire = this.assetForm.days_to_expire
      //   ? parseInt(this.assetForm.days_to_expire)
      //   : "";

      this.assetForm.is_duplicate = this.assetForm.is_duplicate ? 1 : 0;

      if (!this.clientError.length) {
        const formData = new FormData();
        Object.entries(this.assetForm).forEach(([key, value]) => {
          formData.append(key, isEmpty(value) ? "" : value);
        });

        const filesInput = this.$refs.attachments;
        for (let i = 0; i < filesInput.files.length; i++) {
          formData.append("documents[]", filesInput.files[i]);
        }

        const config = {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        };

        const token = localStorage.getItem("token");
        axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;

        let Request;
        if (this.assetForm?.asset_id) {
          Request = axios.post(
            `/asset/${this.assetForm.asset_id}`,
            formData,
            config
          );
        } else {
          Request = axios.post("/asset", formData, config);
        }

        Request.then((response) => {
          this.disabledButton = false;
          if (response.status === 200) {
            this.$refs.attachments.value = "";
            this.$emit("reload-asset-data");
            this.$refs.asset_modal_close.click();
            notification.open({
              message: response?.data?.message || "Successful",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_SUCCESS_COLOR,
              },
            });
          }
        }).catch((error) => {
          this.disabledButton = false;
          if (error.response) {
            var response = error.response;

            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.errors = response?.data?.error;
          } else {
            notification.open({
              message: "Server Error",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
      } else {
        this.disabledButton = false;
      }
    },
    async getEmployee() {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      await axios
        .get("/employees/all")
        .then((response) => {
          const data = response?.data?.data || [];

          this.employees = data.map((emp) => ({
            id: emp.id,
            employee_id: emp.employee_id,
            name: emp.first_name + " " + emp.last_name,
            text: emp.first_name + " " + emp.last_name,
            label_id:
              emp.first_name + " " + emp.last_name + " - " + emp.employee_id,
          }));
        })
        .catch((error) => {
          if (
            error?.response?.status == 401 &&
            response?.data?.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch(() => {});
          }

          if (error?.response) {
            var response = error.response;

            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          } else {
            notification.open({
              message: "Server Error During Fetching Overtime Records",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
  },
  created() {
    this.getEmployee();
    this.fetchAllDepartments();
  },
};
</script>
<style scoped>
select.form-select-lg {
  padding-top: 0.9rem !important;
  padding-bottom: 0.2rem !important;
  font-size: 1rem !important;
}

.select2-container {
  width: 100% !important;
}

.is-invalid .select2-selection {
  border: 1px solid #dc3545 !important;
  border-radius: 0.375rem !important;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.select2-selection:focus,
.select2-selection:focus-visible {
  outline: none !important;
  border-color: #86b7fe !important;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
</style>
